import { render } from "./CenteredWindowBase.vue?vue&type=template&id=323914dc&scoped=true"
import script from "./CenteredWindowBase.vue?vue&type=script&lang=js"
export * from "./CenteredWindowBase.vue?vue&type=script&lang=js"

import "./CenteredWindowBase.vue?vue&type=style&index=0&id=323914dc&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-323914dc"

export default script